<template>
  <div>
    <b-card title="Manual Transaction">
      <!-- search input -->

      <b-row class="mb-1">
        <!-- search input -->
        <b-col>
          <section>
            <b-button
              v-b-modal.modal-filter-refunds
              variant="outline-primary"
              class="d-flex text-primary"
            >
              <feather-icon icon="FilterIcon" />Filter
            </b-button>
          </section>
        </b-col>
        <b-col>
          <b-form-group
            v-if="dataFiltered === true"
            class="d-flex justify-content-center"
          >
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="search"
            />
          </b-form-group>
        </b-col>

        <b-col v-if="dataFiltered === true" class="d-flex justify-content-end">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </b-col>
      </b-row>

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->

          <!-- Column: Status -->
          <span v-if="props.column.field === 'paymentOptionId'">
            <span>
              {{
                paidPaymentOptions.length > 1
                  ? paidPaymentOptions.filter(
                      (f) => props.row.paymentOptionId == f.value,
                    )[0].text
                  : ""
              }}
            </span>
          </span>
          <span v-else-if="props.column.field === 'paymentStatus'">
            <span>
              {{
                statusOptions.filter(
                  (f) => props.row.paymentStatus == f.value,
                )[0].text
              }}
            </span>
          </span>

          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span v-if="props.row.paymentStatus == 1">
              <!-- v-else-if="props.row.Payment_Status==='pending'" -->
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  variant="success"
                  @click="approveOrderException(props.row.id)"
                  v-if="$can('ApproveManualTransaction', 'Report')"
                >
                  <feather-icon icon="CheckIcon" class="mr-50" />

                  <span>Approve</span>
                </b-dropdown-item>
                <b-dropdown-item
                  variant="danger"
                  @click="cancelOrderException(props.row.id)"
                  v-if="$can('CancelManualTransaction', 'Report')"
                >
                  <feather-icon icon="CheckIcon" class="mr-50" />

                  <span>Cancel</span>
                </b-dropdown-item>
                <b-dropdown-item
                  variant="info"
                  @click="resendOrderException(props.row)"
                  v-if="$can('ApproveManualTransaction', 'Report')"
                >
                  <feather-icon icon="CheckIcon" class="mr-50" />

                  <span>Resend</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>
          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30', '50']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <b-modal
        id="modal-filter-refunds"
        title="Filter Reconcilation"
        ok-title="Search"
        cancel-variant="outline-secondary"
        size="lg"
        @ok="filterManualTransaction"
      >
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group label="Custom Order Code">
                <b-form-input
                  id="filtercustomOrderCode-input"
                  v-model="filtercustomOrderCode"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Order Id">
                <b-form-input
                  id="filterflyGateOrderId-input"
                  v-model="filterflyGateOrderId"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Currency">
                <b-form-input
                  id="filtervendorTxnRefNumber-input"
                  v-model="filterCurrency"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Paid FOP">
                <b-form-select
                  v-model="selectedPaidPaymentOptions"
                  :options="paidPaymentOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Reference Number">
                <b-form-input
                  id="filtervendorTxnRefNumber-input"
                  v-model="filtervendorTxnRefNumber"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Ticket Number">
                <b-form-input
                  id="filtervendorTxnRefNumber-input"
                  v-model="filterTicketNumber"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Status">
                <b-form-select
                  v-model="filterStatus"
                  :options="statusOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Transaction Queue Date">
                <flat-pickr
                  v-model="trxnDateRangeQueue"
                  class="form-control"
                  :config="{ mode: 'range', maxDate: 'today' }"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Paid Date Range">
                <flat-pickr
                  v-model="trxnDateRangePaidDate"
                  class="form-control"
                  :config="{ mode: 'range', maxDate: 'today' }"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="From Amount">
                <b-form-input
                  id="fromRequestedAmount-input"
                  v-model.number="fromAmount"
                  type="number"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="To Amount">
                <b-form-input
                  id="toRequestedAmount-input"
                  v-model.number="toAmount"
                  type="number"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>

      <b-modal
        id="modal-cancel-Order-Exception"
        title="Cancel Order Exception"
        centered
        @ok="handleCancelOk"
      >
        <form ref="completeform">
          <b-row>
            <b-col>
              <b-form-group label="Remark">
                <b-form-textarea
                  id="remark-input"
                  v-model="cancelOrderExceptionfield.Remark"
                  :state="cancelOrderExceptionfield.Remark.length > 0"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </b-modal>

      <b-modal
        id="modal-approve-Order-Exception"
        title="Approve Order Exception"
        centered
        @ok="handleApproveOk"
      >
        <form ref="completeform">
          <b-row>
            <b-col>
              <b-form-group label="Remark">
                <b-form-textarea
                  id="remark-input"
                  v-model="approveOrderExceptionfield.Remark"
                  :state="approveOrderExceptionfield.Remark.length > 0"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </b-modal>

      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BButton,
  BForm,
  BModal,
  BSpinner,
  BCardBody,
  BTable,
  BFormTextarea,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import flatPickr from "vue-flatpickr-component";
import axios from "@axios";
import store from "@/store";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";

export default {
  name: "Users",
  components: {
    BRow,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCol,
    BButton,
    BForm,
    BModal,
    BCardBody,
    BTable,
    BFormTextarea,
    BSpinner,
    flatPickr,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  props: {
    proprefundHistory: {
      type: Object,
    },
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      rows: [],
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      rangeDate: null,
      activeRow: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${
        nowDate.getUTCMonth() + 1
      }-${nowDate.getUTCDate()}`,
      trxnDateRangeQueue: "",
      trxnStartDate: "",
      trxnEndDate: "",
      selectedOrder: "",
      filterflyGateOrderId: "",
      filterCurrency: "",
      filtervendorTxnRefNumber: "",
      filtercustomOrderCode: "",
      filterStatus: 0,
      filterTicketNumber: "",
      trxnDateRangePaidDate: "",
      trxnStartDatePaidDate: "",
      selectedPaidPaymentOptions: 0,
      fromAmount: 0,
      toAmount: 0,
      trxnEndDatePaidDate: "",
      columns: [
        {
          label: "Transaction Queue Date",
          field: "transactionQueueDate",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Fly Gate OrderId",
          field: "flyGateOrderId",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Currency",
          field: "currency",
        },
        {
          label: "Paid FOP",
          field: "paymentOptionId",
        },

        {
          label: "Paid Date",
          field: "paidDate",
        },
        {
          label: "Vendor TxnRef No",
          field: "vendorTxnRefNumber",
        },
        {
          label: "Ticket Number",
          field: "ticketNumber",
        },
        {
          label: "Agent",
          field: "agent",
        },
        {
          label: "Payment Status",
          field: "paymentStatus",
        },
        {
          label: "Action Taken By",
          field: "actionTakenBy",
        },
        {
          label: "Action Taken Date",
          field: "actionTakenDate",
        },
        {
          label: "Remark",
          field: "remark",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      paidPaymentOptions: [
        { value: 0, text: "--select Paid Payment Option--" },
      ],
      statusOptions: [
        { value: "0", text: "All" },
        { value: "1", text: "Pending" },
        { value: "2", text: "Approved" },
        { value: "3", text: "Canceled" },
      ],
      selectedCurrency: "ETB",
      searchTerm: "",
      refundworkflowHistory: [],
      refundhistories: [],
      cancelOrderExceptionfield: {
        Id: 0,
        Remark: "",
      },
      approveOrderExceptionfield: {
        Id: 0,
        Remark: "",
      },
      sheets: [{ name: "Detail Refund Requests", data: [] }],
    };
  },

  created() {
    this.fetchallPaymentOptions();
    this.GetCurrentTransaction();
  },
  methods: {
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions",
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paidPaymentOptions.push({
              value: item.paymentOptionId,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    GetCurrentTransaction() {
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Report-ManualTransaction",
      );
      axios
        .get("/Order/api/V1.0/Orders/GetCurrentDateManuallyAddedTransactions ")
        .then((res) => {
          this.rows = [];
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.rows = res.manuallyAddedTransaction;

          res.manuallyAddedTransaction.map((m) => {
            this.sheets[0].data.push({
              "Transaction Queue Date": m.transactionQueueDate,
              "Custom Order Code": m.customOrderCode,
              "Order Id": m.flyGateOrderId,
              Amount: m.amount,
              Currency: m.currency,
              "Paid Payment Option":
                this.paidPaymentOptions.length > 1
                  ? this.paidPaymentOptions.filter(
                      (f) => m.paymentOptionId === f.value,
                    )[0].text
                  : "",
              "Paid Date": m.paidDate,
              "Vendor TxnRef. Number": m.vendorTxnRefNumber,
              "Ticket Number": m.ticketNumber,
              Agent: m.agent,
              Status: this.statusOptions.filter(
                (f) => m.paymentStatus == f.value,
              )[0].text,
              "Action Taken By": m.actionTakenBy,
              "Action Taken Date": m.actionTakenDate,
              Remark: m.remark,
            });
          });
          this.isLoading = false;
        })
        .catch((err) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${err.data.message}`,
            },
          });
          this.isLoading = false;
        });
    },
    filterManualTransaction() {
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Report-ManualTransaction",
      );
      if (this.trxnDateRangeQueue !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRangeQueue.split(" to ");

        if (this.trxnDateRangeQueue.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRangeQueue;
          this.trxnEndDate = this.trxnDateRangeQueue;
        }
      }
      if (this.trxnDateRangePaidDate !== "") {
        const [trxnSttDatePaidDate, trxnEdDatePaidDate] =
          this.trxnDateRangePaidDate.split(" to ");

        if (this.trxnDateRangePaidDate.includes("to")) {
          this.trxnStartDatePaidDate = trxnSttDatePaidDate;
          this.trxnEndDatePaidDate = trxnEdDatePaidDate;
        } else {
          this.trxnStartDatePaidDate = this.trxnDateRangePaidDate;
          this.trxnEndDatePaidDate = this.trxnDateRangePaidDate;
        }
      }

      const url = `/Order/api/V1.0/Orders/FilterManuallyAddedTransactions?OrderId=${this.filterflyGateOrderId}&customOrderCode=${this.filtercustomOrderCode}&vendorTxnRefNumber=${this.filtervendorTxnRefNumber}&paymentOptionId=${this.selectedPaidPaymentOptions}&ticketNumber=${this.filterTicketNumber}&paymentStatus=${this.filterStatus}&fromAmount=${this.fromAmount}&toAmount=${this.toAmount}&FromStartDate=${this.trxnStartDate}&ToStartDate=${this.trxnEndDate}&FromPaidDate=${this.trxnStartDatePaidDate}&ToPaidDate=${this.trxnEndDatePaidDate}&Currency=${this.filterCurrency}`;

      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.rows = res.manuallyAddedTransaction;
          res.manuallyAddedTransaction.map((m) => {
            this.sheets[0].data.push({
              "Transaction Queue Date": m.transactionQueueDate,
              "Custom Order Code": m.customOrderCode,
              "Order Id": m.flyGateOrderId,
              Amount: m.amount,
              Currency: m.currency,
              "Paid Payment Option": this.paidPaymentOptions.filter(
                (f) => m.paymentOptionId === f.value,
              )[0].text,
              "Paid Date": m.paidDate,
              "Vendor TxnRef. Number": m.vendorTxnRefNumber,
              "Ticket Number": m.ticketNumber,
              Agent: m.agent,
              Status: this.statusOptions.filter(
                (f) => m.paymentStatus == f.value,
              )[0].text,
              "Action Taken By": m.actionTakenBy,
              "Action Taken Date": m.actionTakenDate,
              Remark: m.remark,
            });
          });
          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
    handleCancelOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.submitCancelOrderException();
    },
    cancelOrderException(id) {
      this.cancelOrderExceptionfield.Id = id;
      this.$bvModal.show("modal-cancel-Order-Exception");
    },
    submitCancelOrderException() {
      if (this.$refs.completeform.checkValidity()) {
        this.$nextTick(() => {
          this.$bvModal.hide("modal-cancel-Order-Exception");
        });

        this.$bvModal
          .msgBoxConfirm(
            `Are You Sure You Want to Cancel the Order Exception?`,
            {
              title: "Warning",
              size: "sm",
              buttonSize: "sm",
              headerBgVariant: "warning",
              cancelTitle: "NO",
              cancelVariant: "warning",
              okVariant: "primary",
              okTitle: "YES",
              footerClass: "p-2",
              hideHeaderClose: true,
              centered: true,
            },
          )
          .then((value) => {
            if (value) {
              this.isLoading = true;
              this.$store.dispatch(
                "config/getActionPrivilege",
                "Report-CancelManualTransaction",
              );
              axios
                .post(
                  `Order/api/V1.0/Orders/CancelOrderException`,
                  this.cancelOrderExceptionfield,
                )
                .then((res) => {
                  this.isLoading = false;
                  this.$bvModal.msgBoxOk("Data was Canceled successfully", {
                    title: "Confirmation",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  });
                  this.GetCurrentTransaction();
                })
                .catch((res) => {
                  this.isLoading = false;
                  console.log(res);
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: `${res.data.message}`,
                    },
                  });
                  // this.$refs.loginForm.setErrors(error)
                });
            }
          });
      }
    },
    handleApproveOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.submitApproveOrderException();
    },
    approveOrderException(id) {
      this.approveOrderExceptionfield.Id = id;
      this.$bvModal.show("modal-approve-Order-Exception");
    },
    submitApproveOrderException() {
      if (this.$refs.completeform.checkValidity()) {
        this.$nextTick(() => {
          this.$bvModal.hide("modal-approve-Order-Exception");
        });

        this.$bvModal
          .msgBoxConfirm(
            `Are You Sure You Want to Approve the Order Exception?`,
            {
              title: "Warning",
              size: "sm",
              buttonSize: "sm",
              headerBgVariant: "warning",
              cancelTitle: "NO",
              cancelVariant: "warning",
              okVariant: "primary",
              okTitle: "YES",
              footerClass: "p-2",
              hideHeaderClose: true,
              centered: true,
            },
          )
          .then((value) => {
            if (value) {
              this.isLoading = true;
              this.$store.dispatch(
                "config/getActionPrivilege",
                "Report-ApproveManualTransaction",
              );
              axios
                .post(
                  `Order/api/V1.0/Orders/ApproveExceptionOrders`,
                  this.approveOrderExceptionfield,
                )
                .then((res) => {
                  this.isLoading = false;
                  this.$bvModal.msgBoxOk("Data was Approved successfully", {
                    title: "Confirmation",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  });
                  this.GetCurrentTransaction();
                })
                .catch((res) => {
                  this.isLoading = false;
                  console.log(res);
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: `${res.data.message}`,
                    },
                  });
                  // this.$refs.loginForm.setErrors(error)
                });
            }
          });
      }
    },
    resendOrderException(row) {
      this.isLoading = true;
      axios
        .post(`/Order/api/V1.0/Orders/ManualConfirmOrder`, {
          orderId: row.flyGateOrderId,
          vendorTxnRefNumber: row.vendorTxnRefNumber,
          paymentOptionId: row.paymentOptionId,
          amount: row.amount,
          remark: row.remark,
        })
        .then((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.message, {
            title: "Confirmation",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          this.GetCurrentTransaction();
        })
        .catch((res) => {
          this.isLoading = false;
          console.log(res);
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
